<template>
  <div>
    <div class="margin-bottom2px">
      <b-form-select
        v-model="SpcltyDataSelected"
        :options="SpcltyData"
        size="sm"
        class="spclty-css"
      ></b-form-select>
    </div>
    <div class="visit-list-custom">
      <b-list-group>
        <b-list-group-item
          class="align-items-start padding-list-group"
          v-for="item in visitData"
          v-bind:key="item.id"
          button
          variant="primary"
          v-bind:class="{
            'list-group-item-primary':
              item.datas.an == '' || item.datas.an == null,
            'list-group-item-danger':
              item.datas.an != '' && item.datas.an != null,
            active: item.datas.vn == ActiveVN
          }"
        >
          <table style="width:100%;">
            <tr>
              <td style="width:10px;">
                <b-form-checkbox
                  :id="`${'vh' + item.datas.vn}`"
                  :name="`${'vh' + item.datas.vn}`"
                  :value="`${item.datas.vn}`"
                  v-model="HistoryPrintSelect"
                  @change="HistoryPrintChecked($event, `${item.datas.vn}`)"
                ></b-form-checkbox>
              </td>
              <!-- v-b-toggle.nav-collapse-visit -->
              <td
                class="text-align-left"
                aria-expanded="false"
              >
                <div @click="ClickVN(item.datas.vn)" >
                <p class="mb-1">
                  {{
                    thaiDatetimeFc.ThaiDateTime(
                      item.datas.vstdate + " " + item.datas.vsttime
                    )
                  }}
                </p>
                <p class="mb-1 font14px">{{ item.datas.department_name }}</p>

                </div>

                <div
                  v-bind:class="{
                    'display-hidden':
                      item.datas.an == '' || item.datas.an == null,
                    'display-show': item.datas.an != '' && item.datas.an != null
                  }"
                >
                  <p class="mb-1">
                    <b-badge variant="danger" class="font14px" @click="selectAN(item.datas.an)" >AN : {{ item.datas.an }}</b-badge>
                    {{ OperationCk(item.datas.vn, item.datas.an) }}
                  </p>
                </div>

                <div @click="ClickVN(item.datas.vn)" class="pj_clearfix" >
                  <b-img
                    rounded="circle"
                    alt="Lab"
                    title="Lab"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgLabIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn).lab
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    alt="X-ray"
                    title="X-ray"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgXrayIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn).xray
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    alt="ER & OPD ProgressNote"
                    title="ER & OPD ProgressNote"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgErProgressNoteIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn)
                        .ProgressNote
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    alt="Anesthetic Note"
                    title="Anesthetic Note"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgAnestheticNoteIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn)
                        .AnestheticNote
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    alt="Fast Track STEMI"
                    title="Fast Track STEMI"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgFastTrackStemiIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn)
                        .FastTrackStemi
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    alt="PT (กายภาพบำบัด)"
                    title="PT (กายภาพบำบัด)"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgPtIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn).Pt
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    alt="ผ่านศูนย์ตรวจสอบสิทธิแล้ว"
                    title="ผ่านศูนย์ตรวจสอบสิทธิแล้ว"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgIptRightsCenterCkIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn)
                        .AdmitRights
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    alt="Audiogram (การตรวจการได้ยิน)"
                    title="Audiogram (การตรวจการได้ยิน)"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgEarHearingCkIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn).Hearing
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    alt="การออกเอกสารใบรับรองความพิการ"
                    title="การออกเอกสารใบรับรองความพิการ"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgDisabilityCkIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn)
                        .Disability
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    :alt="
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn)
                        .Consult_text
                    "
                    :title="
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn)
                        .Consult_text
                    "
                    width="25"
                    class="icon-css"
                    v-bind:src="imgConsultCkIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn).Consult
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>

                  <b-img
                    rounded="circle"
                    alt="Blood transfusion reaction"
                    title="Blood transfusion reaction"
                    width="25"
                    class="icon-css"
                    v-bind:src="imgLabBtrCkIcon"
                    v-bind:class="[
                      pjFunctionsFc.VNarrayFind(STDVisit, item.datas.vn).LabBtr
                        ? 'display-show'
                        : 'display-hidden',
                      false
                    ]"
                  ></b-img>
                </div>
              </td>
            </tr>
          </table>
        </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import PatientData from "@/models/patientEMRs/PatientData";
import PatientVisit from "@/models/patientEMRs/PatientVisit";
import PatientLabHead from "@/models/patientEMRs/PatientLabHead";
import PatientXrayHead from "@/models/patientEMRs/PatientXrayHead";
import PatientOpdErProgressNote from "@/models/patientEMRs/PatientOpdErProgressNote";
import PatientOpdAnestheticNote from "@/models/patientEMRs/PatientOpdAnestheticNote";
import PatientOpdFastTrackStemi from "@/models/patientEMRs/PatientOpdFastTrackStemi";
import PatientEmrPtData from "@/models/patientEMRs/PatientEmrPtData";
import PatientAdmitRightsCenterHead from "@/models/patientEMRs/PatientAdmitRightsCenterHead";
import PatientEmrEarHearingDetail from "@/models/patientEMRs/PatientEmrEarHearingDetail";
import PatientEmrDisabilityData from "@/models/patientEMRs/PatientEmrDisabilityData";
import PatientEmrConsultData from "@/models/patientEMRs/PatientEmrConsultData";
import PatientOpdHistoryPrintData from "@/models/patientEMRs/PatientOpdHistoryPrintData";
import LabBtrData from "@/models/patientEMRs/LabBtrData";

import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
const LabimgIcon = require("@/images/Lab-Icon.png");
const XrayimgIcon = require("@/images/Xray-Icon.png");
const ErProgressNoteIcon = require("@/images/ErProgressNote-Icon.png");
const AnestheticNoteIcon = require("@/images/AnestheticNote-Icon.png");
const FastTrackStemiIcon = require("@/images/FastTrackStemi-Icon.png");
const PtIcon = require("@/images/pt.png");
const IptRightsCenterCkIcon = require("@/images/Complete_Symbol-512.png");
const EarHearingCkIcon = require("@/images/EarHearing-Icon.png");
const DisabilityCkIcon = require("@/images/Disability-Icon.png");
const ConsultCkIcon = require("@/images/icon-consult.png");
const LabBtrCkIcon = require("@/images/blood_drop_type_b_medical-512.png");

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      ActiveVN: "",
      ptImage: "",
      visitData: null,
      imgLabIcon: LabimgIcon,
      imgXrayIcon: XrayimgIcon,
      imgErProgressNoteIcon: ErProgressNoteIcon,
      imgAnestheticNoteIcon: AnestheticNoteIcon,
      imgFastTrackStemiIcon: FastTrackStemiIcon,
      imgIptRightsCenterCkIcon: IptRightsCenterCkIcon,
      imgPtIcon: PtIcon,
      imgEarHearingCkIcon: EarHearingCkIcon,
      imgDisabilityCkIcon: DisabilityCkIcon,
      imgConsultCkIcon: ConsultCkIcon,
      imgLabBtrCkIcon: LabBtrCkIcon,
      thaiDatetimeFc: null,
      componentName: true,
      ptHN: "",
      ptVN: "",
      isLoading: false,
      HistoryPrintSelect: [],
      STDVisit: [
        {
          vn: "",
          lab: false,
          xray: false,
          ProgressNote: false,
          AnestheticNote: false,
          FastTrackStemi: false,
          Pt: false,
          AdmitRights: false,
          Hearing: false,
          Disability: false,
          Consult: false,
          Consult_text: false,
          History_print: false,
          LabBtr: false
        }
      ],
      SpcltyDataSelected: null,
      SpcltyData: [],
      OpdHistoryPrintDataCK: false
    };
  },
  props: ["MyVn", "MyHn", "PtHistoryprint"],
  component: {
    PatientData,
    PatientVisit,
    PatientLabHead,
    PatientXrayHead,
    thaiDatetime,
    pjFunctions,
    PatientOpdErProgressNote,
    PatientOpdAnestheticNote,
    PatientOpdFastTrackStemi,
    PatientEmrPtData,
    PatientAdmitRightsCenterHead,
    PatientEmrEarHearingDetail,
    PatientEmrConsultData,
    PatientOpdHistoryPrintData,
    LabBtrData
  },
  created() {
    this.hnChangVisit,
      (this.thaiDatetimeFc = thaiDatetime.methods),
      this.hnChang;
    this.ActiveVN = this.$store.get("systems@vnEMR");
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {
    ptHN: function() {
      this.hnChangVisit(this.ptHN);
      this.getSpcltyData(this.ptHN);
    },
    ptVN: function() {
      this.hnChangVisit(this.ptHN);
      this.ActiveVN = this.MyVn;
      this.getSpcltyData(this.ptHN);
    },
    MyHn: function() {
      this.hnChang;
    },
    MyVn: function() {
      this.hnChang;
    },
    SpcltyDataSelected: function() {
      this.hnChangVisit(this.ptHN);
    },
    PtHistoryprint: function() {
      // this.HistoryPrintCkeck(this.ptHN);

      this.STDVisit = [];

      this.hnChangVisit(this.ptHN);
    }
  },
  computed: {
    hnChang() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
    }
  },
  methods: {
    HistoryPrintChecked(e, vn) {
      if (e != "" && e != null && e != "null") {
        let ScrObj = PatientVisit.query()
          .where(record => record.datas.hn == this.ptHN)
          .where(record => record.datas.vn == vn)
          .get();

        let data = [];
        let data2 = [];
        let dtID = 0;
        for (let val of ScrObj) {
          if (
            val.datas.vstdate != "" &&
            val.datas.vstdate != "null" &&
            val.datas.vstdate != null &&
            val.datas.vsttime != "" &&
            val.datas.vsttime != "null" &&
            val.datas.vsttime != null
          ) {
            dtID = this.thaiDatetimeFc.DateTimeId(
              val.datas.vstdate + " " + val.datas.vsttime
            );
          }

          data2.push({
            hospCode: val.datas.hospCode,
            hospName: val.datas.hospName,
            vn: vn,
            hn: val.datas.hn,
            loginname: this.$store.get("systems@LoginData").UserId,
            log_datetime: this.thaiDatetimeFc.DateTimeNow(),
            department: val.datas.department_name,
            vstdate: val.datas.vstdate,
            vsttime: val.datas.vsttime,
            doctor_name: val.datas.doctor_name
          });

          data.push({
            id: this.$store.get("systems@LoginData").UserId + vn,
            loginname: this.$store.get("systems@LoginData").UserId,
            hn: val.hn,
            vn: vn,
            log_datetime: this.thaiDatetimeFc.DateTimeNow(),
            datas: data2[0],
            visit_orderby: dtID
          });
        }

        let STD = PatientOpdHistoryPrintData.insertOrUpdate({
          data
        });

        store.set("systems@ptHistoryPrint", STD);
      } else {
        let STD = PatientOpdHistoryPrintData.delete({
          where(record) {
            return record.vn == vn;
          }
        });
        store.set("systems@ptHistoryPrint", STD);

        /*
        // #### Patient Opd History Print Save ####
        let DataLoadObj = this;
        this.axios
          .post(
            this.$store.get("systems@UrlApi") + "PatientOpdHistoryPrintSave",
            {
              CompanyId: this.$store.get("systems@CompanyId"),
              ApiKey: this.$store.get("systems@ApiKey"),
              hn: this.ptHN,
              vn: vn
            }
          )
          .then(function(response) {
            DataLoadObj.output = response.data;
          })
          .catch(function(error) {
            DataLoadObj.output = error;
            console.log("PatientOpdHistoryPrintSave : " + DataLoadObj.output);
          })
          .finally(function() {
            // DataLoadObj.loadOpdHistoryPrintData(DataLoadObj.ptHN, vn);
            store.set(
              "systems@ptHistoryPrint",
              DataLoadObj.thaiDatetimeFc.DateTimeNow()
            );
          });
      } else {
        // #### Patient Opd History Print Delete ####
        let DataLoadObj = this;
        this.axios
          .post(
            this.$store.get("systems@UrlApi") + "PatientOpdHistoryPrintDelete",
            {
              CompanyId: this.$store.get("systems@CompanyId"),
              ApiKey: this.$store.get("systems@ApiKey"),
              hn: DataLoadObj.ptHN,
              vn: vn
            }
          )
          .then(function(response) {
            DataLoadObj.output = response.data;
          })
          .catch(function(error) {
            DataLoadObj.output = error;
            console.log("PatientOpdHistoryPrintDelete : " + DataLoadObj.output);
          })
          .finally(function() {
            // DataLoadObj.loadOpdHistoryPrintData(DataLoadObj.ptHN, vn);
            store.set(
              "systems@ptHistoryPrint",
              DataLoadObj.thaiDatetimeFc.DateTimeNow()
            );
          });
        */
      }
    },
    loadOpdHistoryPrintData(hn, vn) {
      /*
      let DataLoadObj = this;
      let data = [];
      let val = null;

      // #### Patient Opd History PrintData ####
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "PatientOpdHistoryPrintData",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn
          }
        )
        .then(function(response) {
          DataLoadObj.output = response.data;
          if (DataLoadObj.output.status === true) {
            PatientOpdHistoryPrintData.delete({
              where(record) {
                return record.hn == hn;
              }
            });

            data = [];
            let dtID = 0;
            for (val of DataLoadObj.output.result) {
              if (
                val.vstdate != "" &&
                val.vstdate != "null" &&
                val.vstdate != null &&
                val.vsttime != "" &&
                val.vsttime != "null" &&
                val.vsttime != null
              ) {
                dtID = DataLoadObj.thaiDatetimeFc.DateTimeId(
                  val.vstdate + " " + val.vsttime
                );
              }

              data.push({
                id: val.loginname + val.vn,
                loginname: val.loginname,
                hn: val.hn,
                vn: val.vn,
                log_datetime: val.log_datetime,
                datas: val,
                visit_orderby: dtID
              });
            }

            PatientOpdHistoryPrintData.insertOrUpdate({
              data
            });
          } else {
            if (DataLoadObj.output.ErrorMessage === "Data Not Found") {
              PatientOpdHistoryPrintData.delete({
                where(record) {
                  return record.hn == hn;
                }
              });
            }
          }
        })
        .catch(function(error) {
          DataLoadObj.output = error;
          console.log("PatientOpdHistoryPrintData : " + DataLoadObj.output);
        })
        .finally(function() {
          store.set(
            "systems@ptHistoryPrint",
            DataLoadObj.thaiDatetimeFc.DateTimeNow()
          );
        });
      */
    },
    /*
    HistoryPrintCkeck(hn) {
      console.log(hn, this.HistoryPrintSelect);
      for (let vn of this.HistoryPrintSelect) {

        let OpdHistoryPrintDataObj = PatientOpdHistoryPrintData.query()
          .where(record => record.hn == hn)
          .where(record => record.vn == vn)
          .where(
            record =>
              record.loginname == this.$store.get("systems@LoginData").UserId
          )
          .get();

        console.log("oo", OpdHistoryPrintDataObj.length);

        if (OpdHistoryPrintDataObj.length <= 0) {
          console.log("DDD", vn);

          // #### Patient Opd History Print Save ####
          let DataLoadObj = this;
          this.axios
            .post(
              this.$store.get("systems@UrlApi") + "PatientOpdHistoryPrintSave",
              {
                CompanyId: this.$store.get("systems@CompanyId"),
                ApiKey: this.$store.get("systems@ApiKey"),
                hn: hn,
                vn: vn
              }
            )
            .then(function(response) {
              DataLoadObj.output = response.data;
            })
            .catch(function(error) {
              DataLoadObj.output = error;
              console.log("PatientOpdHistoryPrintSave : " + DataLoadObj.output);
            });
          // .finally(function() {
          //  DataLoadObj.OpdHistoryPrintDataLoadSTD = true;
          //  DataLoadObj.getOpdHistoryPrintData(hn);
          // });
        }
      }
    },
    */
    OperationCk(vn, an) {
      if (!this.pjFunctionsFc.VNarrayFind(this.STDVisit, vn)) {
        let LabObj = PatientLabHead.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .get();

        let labCK = false;
        if (LabObj != "") {
          labCK = true;
        } else {
          labCK = false;
        }

        let XrayObj = PatientXrayHead.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .get();

        let xrayCK = false;
        if (XrayObj != "") {
          xrayCK = true;
        } else {
          xrayCK = false;
        }

        let ErProgressNoteObj = PatientOpdErProgressNote.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .get();

        let ErProgressNoteCK = false;

        if (ErProgressNoteObj != "") {
          ErProgressNoteCK = true;
        } else {
          ErProgressNoteCK = false;
        }

        let AnestheticNoteObj = PatientOpdAnestheticNote.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .get();

        let AnestheticNoteCK = false;
        if (AnestheticNoteObj != "") {
          AnestheticNoteCK = true;
        } else {
          AnestheticNoteCK = false;
        }

        let FastTrackStemiObj = PatientOpdFastTrackStemi.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .get();

        let FastTrackStemiCK = false;
        if (FastTrackStemiObj != "") {
          FastTrackStemiCK = true;
        } else {
          FastTrackStemiCK = false;
        }

        let PtDataObj = PatientEmrPtData.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .get();

        let PtCK = false;
        if (PtDataObj != "") {
          PtCK = true;
        } else {
          PtCK = false;
        }

        let PtAdmitRightsDataObj = PatientAdmitRightsCenterHead.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.an == an)
          .get();

        let AdmitRightsCK = false;
        if (PtAdmitRightsDataObj != "") {
          AdmitRightsCK = true;
        } else {
          AdmitRightsCK = false;
        }

        let EarHearingDetailObj = PatientEmrEarHearingDetail.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .get();

        let HearingCK = false;
        if (EarHearingDetailObj != "") {
          HearingCK = true;
        } else {
          HearingCK = false;
        }

        let PtEmrEarDisabilityObj = PatientEmrDisabilityData.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .get();

        let DisabilityCK = false;
        if (PtEmrEarDisabilityObj != "") {
          DisabilityCK = true;
        } else {
          DisabilityCK = false;
        }

        let EmrConsultDataObj = PatientEmrConsultData.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .get();

        let ConsultCK = false;
        let ConsultCK_text = "";
        if (EmrConsultDataObj != "") {
          ConsultCK = true;
          ConsultCK_text = EmrConsultDataObj[0].consult_text;
        } else {
          ConsultCK = false;
          ConsultCK_text = "";
        }

        let OpdHistoryPrintDataObj = PatientOpdHistoryPrintData.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .where(
            record =>
              record.loginname == this.$store.get("systems@LoginData").UserId
          )
          .get();

        let OpdHistoryPrintCK = false;
        if (OpdHistoryPrintDataObj != "") {
          if (this.HistoryPrintSelect.indexOf(vn, 0) < 0) {
            this.HistoryPrintSelect.push(vn);
          }

          OpdHistoryPrintCK = true;
        } else {
          // this.HistoryPrintSelect.splice(this.HistoryPrintSelect.indexOf(vn));

          const index = this.HistoryPrintSelect.indexOf(vn, 0);
          if (index > -1) {
            this.HistoryPrintSelect.splice(index, 1);
          }

          OpdHistoryPrintCK = false;
        }

        let LabBtrObj = LabBtrData.query()
          .where(record => record.hn == this.$store.get("systems@hnEMR"))
          .where(record => record.vn == vn)
          .where(record => record.btr_status == "Y")
          .get();

        let LabBtrCK = false;
        if (LabBtrObj != "") {
          LabBtrCK = true;
        } else {
          LabBtrCK = false;
        }

        this.STDVisit.push({
          vn: vn,
          lab: labCK,
          xray: xrayCK,
          ProgressNote: ErProgressNoteCK,
          AnestheticNote: AnestheticNoteCK,
          FastTrackStemi: FastTrackStemiCK,
          Pt: PtCK,
          AdmitRights: AdmitRightsCK,
          Hearing: HearingCK,
          Disability: DisabilityCK,
          Consult: ConsultCK,
          Consult_text: ConsultCK_text,
          History_print: OpdHistoryPrintCK,
          LabBtr: LabBtrCK
        });
      }

      /*else {
        if (!this.OpdHistoryPrintDataCK) {
          let OpdHistoryPrintDataObj = PatientOpdHistoryPrintData.query()
            .where(record => record.hn == this.$store.get("systems@hnEMR"))
            .where(record => record.vn == vn)
            .where(
              record =>
                record.loginname == this.$store.get("systems@LoginData").UserId
            )
            .get();

          if (OpdHistoryPrintDataObj != "") {
            this.HistoryPrintSelect.push(vn);
          }
          this.OpdHistoryPrintDataCK = true;
        }
      }*/
    },
    getSpcltyData(hn) {
      // this.SpcltyDataSelected = null;

      let ScrObj = PatientVisit.query()
        .where(record => record.datas.hn == hn)
        .get();

      if (ScrObj.length > 0) {
        let data = [];
        data.push({
          value: null,
          text: ".:: แสดงทุกแผนก ::."
        });
        for (var val of ScrObj) {
          if (!data.find(data => data.value === val.datas.spclty)) {
            data.push({
              value: val.datas.spclty,
              text: val.datas.spclty_name
            });
          }
        }

        this.SpcltyData = data;
      } else {
        this.SpcltyData = [];
      }
    },
    hnChangVisit(hn) {
      if (
        PatientVisit.query()
          .where("hn", hn)
          .get()[0]
      ) {
        if (
          (this.$route.params.vn == "" || this.$route.params.vn == null) &&
          hn != "" &&
          hn != null
        ) {
          let DataObj = [];
          if (
            this.SpcltyDataSelected == null ||
            this.SpcltyDataSelected == "null" ||
            this.SpcltyDataSelected == ""
          ) {
            DataObj = PatientVisit.query()
              .where(record => record.datas.hn == hn)
              .orderBy("visit_orderby", "desc")
              .get();
          } else {
            DataObj = PatientVisit.query()
              .where(record => record.datas.hn == hn)
              .where(record => record.datas.spclty == this.SpcltyDataSelected)
              .orderBy("visit_orderby", "desc")
              .get();
          }

          if (DataObj[0].datas.vn != "") {
            this.visitData = DataObj;

            store.set("systems@vnEMR", DataObj[0].datas.vn);

            if (
              DataObj[0].datas.vn != "" &&
              DataObj[0].datas.vn != null &&
              this.$route.params.vn != DataObj[0].datas.vn
            ) {
              this.$router.push({
                path:
                  "/PatientEMR/" +
                  this.$store.get("systems@hnEMR") +
                  "/" +
                  DataObj[0].datas.vn
              });
            }

            let anObj = PatientVisit.query()
              .where(record => record.datas.vn == DataObj[0].datas.vn)
              .get()[0];

            if (anObj) {
              if (anObj.datas.an) {
                store.set("systems@anEMR", anObj.datas.an);
              } else {
                store.set("systems@anEMR", "");
              }
            }
          }
        } else {
          let DataObj = [];
          if (
            this.SpcltyDataSelected == null ||
            this.SpcltyDataSelected == "null" ||
            this.SpcltyDataSelected == ""
          ) {
            DataObj = PatientVisit.query()
              .where(record => record.datas.hn == hn)
              .orderBy("visit_orderby", "desc")
              .get();
          } else {
            DataObj = PatientVisit.query()
              .where(record => record.datas.hn == hn)
              .where(record => record.datas.spclty == this.SpcltyDataSelected)
              .orderBy("visit_orderby", "desc")
              .get();
          }

          if (DataObj[0].datas.vn != "") {
            this.visitData = DataObj;

            // console.log("ll", this.visitData);

            store.set("systems@vnEMR", this.$route.params.vn);

            if (
              this.$route.params.vn != "" &&
              this.$route.params.vn != null &&
              this.$route.params.vn != this.$route.params.vn
            ) {
              this.$router.push({
                path:
                  "/PatientEMR/" +
                  this.$store.get("systems@hnEMR") +
                  "/" +
                  this.$route.params.vn
              });
            }

            let anObj = PatientVisit.query()
              .where(record => record.datas.vn == this.$route.params.vn)
              .get()[0];

            if (anObj) {
              if (anObj.datas.an) {
                store.set("systems@anEMR", anObj.datas.an);
              } else {
                store.set("systems@anEMR", "");
              }
            }
          }
        }
      }
    },
    ClickVN(vn) {
      this.ActiveVN = vn;

      if (this.$store.get("systems@PageWidth") <= 991) {
        // this.$root.$emit("bv::toggle::collapse", "nav-collapse-visit");
        this.$root.$emit("bv::toggle::collapse", "nav-collapse-visit");
      }

      store.set("systems@SpinnersShow", true);

      setTimeout(() => {
        this.selectVisit(vn);
      }, 500);
    },
    selectVisit(vn) {
      let anObj = PatientVisit.query()
        .where(record => record.datas.vn == vn)
        .get()[0];

      if (anObj.datas.an) {
        store.set("systems@anEMR", anObj.datas.an);
      } else {
        store.set("systems@anEMR", "");
      }

      if (vn != "" && vn != null && vn != this.$route.params.vn) {
        this.$router.push({
          path: "/PatientEMR/" + this.$store.get("systems@hnEMR") + "/" + vn
        });
      }

      store.set("systems@vnEMR", vn);

      setTimeout(() => {
        store.set("systems@SpinnersShow", false);
      }, 1000);
    },
    LabVisitck(vn) {
      let LabObj = PatientLabHead.query()
        .where(record => record.hn == this.$store.get("systems@hnEMR"))
        .where(record => record.vn == vn)
        .get();

      if (LabObj != "") {
        // console.log(LabObj[0].datas)
        return LabObj[0].datas;
      } else {
        return null;
      }
    },
    XrayVisitck(vn) {
      let XrayObj = PatientXrayHead.query()
        .where(record => record.hn == this.$store.get("systems@hnEMR"))
        .where(record => record.vn == vn)
        .get();

      if (XrayObj != "") {
        return XrayObj[0].datas;
      } else {
        return null;
      }
    },
    ErProgressNoteVisitck(vn) {
      let ErProgressNoteObj = PatientOpdErProgressNote.query()
        .where(record => record.hn == this.$store.get("systems@hnEMR"))
        .where(record => record.vn == vn)
        .get();

      if (ErProgressNoteObj != "") {
        return ErProgressNoteObj[0].datas;
      } else {
        return null;
      }
    },
    AnestheticVisitck(vn) {
      let AnestheticNoteObj = PatientOpdAnestheticNote.query()
        .where(record => record.hn == this.$store.get("systems@hnEMR"))
        .where(record => record.vn == vn)
        .get();

      if (AnestheticNoteObj != "") {
        return AnestheticNoteObj[0].datas;
      } else {
        return null;
      }
    },
    FastTrackStemiVisitck(vn) {
      let FastTrackStemiObj = PatientOpdFastTrackStemi.query()
        .where(record => record.hn == this.$store.get("systems@hnEMR"))
        .where(record => record.vn == vn)
        .get();

      if (FastTrackStemiObj != "") {
        return FastTrackStemiObj[0].datas;
      } else {
        return null;
      }
    },

    PtDataVisitck(vn) {
      let PtDataObj = PatientEmrPtData.query()
        .where(record => record.hn == this.$store.get("systems@hnEMR"))
        .where(record => record.vn == vn)
        .get();

      if (PtDataObj != "") {
        return PtDataObj[0].datas;
      } else {
        return null;
      }
    },
    PtAdmitRights(an) {
      let PtAdmitRightsDataObj = PatientAdmitRightsCenterHead.query()
        .where(record => record.hn == this.$store.get("systems@hnEMR"))
        .where(record => record.an == an)
        .get();

      if (PtAdmitRightsDataObj != "") {
        return PtAdmitRightsDataObj[0].datas;
      } else {
        return null;
      }
    },

    PtEarHearing(vn) {
      let EarHearingDetailObj = PatientEmrEarHearingDetail.query()
        .where(record => record.hn == this.$store.get("systems@hnEMR"))
        .where(record => record.vn == vn)
        .get();

      if (EarHearingDetailObj != "") {
        return EarHearingDetailObj[0].datas;
      } else {
        return null;
      }
    },

    PtDisability(vn) {
      let PtEmrEarHearingDetailObj = PatientEmrDisabilityData.query()
        .where(record => record.hn == this.$store.get("systems@hnEMR"))
        .where(record => record.vn == vn)
        .get();

      if (PtEmrEarHearingDetailObj != "") {
        return PtEmrEarHearingDetailObj[0].datas;
      } else {
        return null;
      }
    },
    selectAN(an){

      if (this.$store.get("systems@PageWidth") <= 991) {
        // this.$root.$emit("bv::toggle::collapse", "nav-collapse-visit");
        this.$root.$emit("bv::toggle::collapse", "nav-collapse-visit");
      }

      store.set("systems@anEMR", an);
      setTimeout(() => {
        // v-b-modal.modal-admit-data
        this.$bvModal.show('modal-admit-data');
      }, 500);
      
    }
  }
})
export default class EmrPatientVisit extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}

.icon-css {
  margin-right: 4px;
  float: left;
}

.spclty-css {
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid #ced4da !important;
}
</style>

